import AccountReceivableForm from '@/components/Registry/BillToReceive/AccountReceivableForm';
import { useAccountReceivableCreate } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { AccountReceivableFormValues } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { Form, Modal, ModalProps } from 'antd';
import { Moment } from 'moment';
import { useEffect } from 'react';

interface InitialData {
  description?: string;
  value?: number;
  payDate?: Moment;
  bankAccountId?: number;
}

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  initialData?: InitialData;
}

export default function AccountReceivableCreateModal({
  initialData,
  ...props
}: Props) {
  const [form] = Form.useForm<AccountReceivableFormValues>();

  const accountReceivableCreate = useAccountReceivableCreate();

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        description: initialData.description,
        installmentValue: initialData.value,
        dueDate: initialData.payDate,
        bankAccountId: initialData.bankAccountId,
      });
    }
  }, [initialData]);

  function handleCancel() {
    props.onCancel();
    form.resetFields();
  }

  async function handleSubmit() {
    const values = await form.validateFields();

    delete values.customerName;
    delete values.insurerName;
    delete values.netValue;

    await accountReceivableCreate.mutateAsync({
      ...values,
      payDay: values.payDay?.format(),
      dueDate: values.dueDate?.format(),
      emissionDate: values.emissionDate?.format(),
      installmentNumber: 1,
    });

    handleCancel();
  }

  return (
    <Modal
      {...props}
      title="Criação de Contas a Receber"
      okText="Criar"
      width={1300}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={accountReceivableCreate.isLoading}
    >
      <AccountReceivableForm form={form} />
    </Modal>
  );
}
